export default () => ({
  billing: [],
  patientAccounts: [],
})
